import { ClauseCard } from "../../../components/ClauseCard";
import { IClause } from "../../../interfaces";
import { ClauseCardMode } from "../../../types/enums";
import { FootnoteItem } from "../../../types/enums/FootnoteItem";

type RenderSuggestionProps = {
  idx: number;
  clause: IClause;
  workspaceId: string;
  appId: string;
  context: any;
};

export const RenderSuggestion = ({ idx, clause, context, workspaceId, appId }: RenderSuggestionProps) => {
  const { originalText, unusualPhrases, shouldRedlineSimilarClause, onOpenDocumentViewer } = context;
  return (
    <div key={idx} style={{ paddingRight: "5px", paddingLeft: "1px", marginBottom: "15px" }}>
      <ClauseCard
        footNoteItems={[FootnoteItem.RELEVANCY, FootnoteItem.DOCUMENTS]}
        key={clause.clause_id}
        mode={ClauseCardMode.BROWSE}
        clause={clause}
        searchText={originalText}
        unusualPhrases={unusualPhrases?.[clause.clause_id]}
        readlineEnabled={shouldRedlineSimilarClause}
        onOpenDocument={onOpenDocumentViewer}
        workspaceId={workspaceId}
        appId={appId}
      />
    </div>
  );
};
